var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.485.819a.75.75 0 0 1 0 1.06L7.182 7.183a.75.75 0 0 1-1.06 0L.817 1.879A.75.75 0 1 1 1.878.82l4.774 4.773L11.425.819a.75.75 0 0 1 1.06 0Z",
    fill: "#09205D"
  })));
};

export default SvgArrowDown;